
import Vue from "vue";
import Component from "vue-class-component";
import HeaderRegister from "@/components/register/HeaderRegister.vue";
import AppFooter from "@/components/layout/AppFooter.vue";
import { Action, Getter, State } from "vuex-class";
import AppNavbarSecondary from "@/components/layout/AppNavbarSecondary.vue";

@Component({
  components: {
    AppNavbarSecondary,
    HeaderRegister,
    AppFooter,
  },
})
export default class SetPasswordFree extends Vue {
  @Action("reset", { namespace: "school" })
  private schoolReset: any;
  @Action("reset", { namespace: "candidate" })
  private candidateReset: any;
  @Action("reset", { namespace: "company" })
  private companyReset: any;
  @Action("requestSetCredentialFree", { namespace: "school" })
  private requestSetCredentialFree: any;
  @Action("requestTakeover", { namespace: "school" })
  private requestTakeover: any;

  @State("school", { namespace: "school" })
  private school!: any;
  @State("template", { namespace: "school" })
  private template!: any;

  @Getter("twoColor")
  private twoColor!: { text: string; bg: string; border: string };

  private password = "";
  private confirmPassword = "";

  private get twoBgColor() {
    return this.twoColor.bg;
  }

  private get isSetPassword() {
    return this.$route.name === "set-password";
  }
  private get isTakeover() {
    return this.$route.name === "takeover";
  }

  private get templateNumber() {
    return Number(this.$route.query.template) || 1;
  }

  private submit() {
    this.requestSetCredentialFree({
      params: {
        subdomain: this.school.subdomain,
        password: this.password,
        confirm_password: this.confirmPassword,
      },
      success: () => {
        window.open(
          process.env.NODE_ENV === "development"
            ? "https://sso-uat.career.support"
            : "https://sso.career.support",
          "_self"
        );
      },
    });
  }

  private togglePassword(field: any, eye: any) {
    const password = document.getElementById(field);
    password?.setAttribute(
      "type",
      password?.getAttribute("type") === "password" ? "text" : "password"
    );
    document.getElementById(eye)?.classList.toggle("bi-eye");
  }
}
